
import { City } from '../data/types/city-types';
import { chiapas_cities } from '../data/chiapas/cities-data';
import { hidalgo_cities } from '../data/hidalgo/cities-data';

// Additional city data for other Mexican regions
// These are placeholder cities for demonstration
// In a real implementation, this would be imported from data files
const other_mexican_cities: City[] = [
  // Sonora cities (Northern Mexico)
  {
    id: "hermosillo",
    city_id: "SON-01",
    name: "Hermosillo",
    region_id: "SON",
    coordinates: [-110.9559, 29.0729],
    population: 850000,
    church_presence: "Low",
    funding_amount: 125000,
    funding_percentage: 35
  },
  {
    id: "obregon",
    city_id: "SON-02",
    name: "Ciudad Obregón",
    region_id: "SON",
    coordinates: [-109.9333, 27.4833],
    population: 430000,
    church_presence: "Unreached",
    funding_amount: 75000,
    funding_percentage: 20
  },
  // Chihuahua cities
  {
    id: "chihuahua",
    city_id: "CHIH-01",
    name: "Chihuahua",
    region_id: "CHIH",
    coordinates: [-106.0691, 28.6353],
    population: 925000,
    church_presence: "Low",
    funding_amount: 215000,
    funding_percentage: 42
  },
  {
    id: "juarez",
    city_id: "CHIH-02", 
    name: "Ciudad Juárez",
    region_id: "CHIH",
    coordinates: [-106.4245, 31.7300],
    population: 1500000,
    church_presence: "Low",
    funding_amount: 320000,
    funding_percentage: 38
  },
  // Durango cities
  {
    id: "durango",
    city_id: "DGO-01",
    name: "Durango",
    region_id: "DGO",
    coordinates: [-104.6531, 24.0277],
    population: 650000,
    church_presence: "Unreached",
    funding_amount: 110000,
    funding_percentage: 25
  },
  // Coahuila cities
  {
    id: "saltillo",
    city_id: "COAH-01",
    name: "Saltillo",
    region_id: "COAH",
    coordinates: [-101.0053, 25.4333],
    population: 820000,
    church_presence: "Low",
    funding_amount: 185000,
    funding_percentage: 31
  },
  {
    id: "torreon",
    city_id: "COAH-02",
    name: "Torreón",
    region_id: "COAH",
    coordinates: [-103.4068, 25.5428],
    population: 720000,
    church_presence: "Unreached",
    funding_amount: 150000,
    funding_percentage: 27
  },
  // Baja California Norte
  {
    id: "tijuana",
    city_id: "BCN-01",
    name: "Tijuana",
    region_id: "BCN",
    coordinates: [-117.0382, 32.5149],
    population: 1800000,
    church_presence: "Low",
    funding_amount: 290000,
    funding_percentage: 36
  },
  {
    id: "ensenada",
    city_id: "BCN-02",
    name: "Ensenada",
    region_id: "BCN",
    coordinates: [-116.6058, 31.8667],
    population: 520000,
    church_presence: "Unreached",
    funding_amount: 95000,
    funding_percentage: 22
  }
];

export const getCitiesByRegion = (regionId: string): City[] => {
  switch (regionId) {
    case 'CHIS':
      return chiapas_cities;
    case 'HGO':
      return hidalgo_cities;
    case 'SON':
      return other_mexican_cities.filter(city => city.region_id === 'SON');
    case 'CHIH':
      return other_mexican_cities.filter(city => city.region_id === 'CHIH');
    case 'DGO':
      return other_mexican_cities.filter(city => city.region_id === 'DGO');
    case 'COAH':
      return other_mexican_cities.filter(city => city.region_id === 'COAH');
    case 'BCN':
      return other_mexican_cities.filter(city => city.region_id === 'BCN');
    default:
      return [];
  }
};

export const getAllMexicoCities = (): City[] => {
  // Combine all cities from all regions
  return [...chiapas_cities, ...hidalgo_cities, ...other_mexican_cities];
};

export const validateCityCoordinates = (cities: City[]): City[] => {
  // Filter out cities with invalid coordinates
  return cities.filter(city => 
    city.coordinates && 
    Array.isArray(city.coordinates) && 
    city.coordinates.length === 2 && 
    !isNaN(city.coordinates[0]) && 
    !isNaN(city.coordinates[1]) && 
    city.coordinates[0] !== 0 && 
    city.coordinates[1] !== 0
  );
};

export const getCityById = (cityId: string): City | undefined => {
  const allCities = [...chiapas_cities, ...hidalgo_cities, ...other_mexican_cities];
  return allCities.find(city => city.city_id === cityId || city.id === cityId);
};

export const getLowOrUnreachedCities = (): City[] => {
  const allCities = getAllMexicoCities();
  return allCities.filter(city => 
    city.church_presence === 'Low' || 
    city.church_presence === 'Unreached'
  );
};
